import React from 'react'

type Props = {
	className?: string
}

export function IconX({ className }: Props) {
	return (
		<svg viewBox="0 0 24 24">
			<path
				d="M6.39953 18.6538L5.3457 17.6L10.9457 12L5.3457 6.40002L6.39953 5.34619L11.9995 10.9462L17.5995 5.34619L18.6534 6.40002L13.0534 12L18.6534 17.6L17.5995 18.6538L11.9995 13.0538L6.39953 18.6538Z"
				fill="currentColor"
			/>
		</svg>
	)
}
